import type { ModalProps } from "@components/contracts/Modal.types";
import type React from "react";
import { Modal as RsModal } from "rsuite";

import "./Modal.component.scss";

export const RsuiteModal: React.FC<ModalProps> = ({
  children,
  header,
  onClose,
  title,
  ...props
}) => (
  <RsModal {...props} className="custom" onClose={() => onClose?.()}>
    <RsModal.Header>
      <RsModal.Title>{title}</RsModal.Title>
      {header}
    </RsModal.Header>

    <RsModal.Body>{children}</RsModal.Body>
  </RsModal>
);
